/* =============================================================================
   vp-cart-drawer-de.js — deutsche Beschriftungen im Warenkorb
   01.09.2026

   In der Warenkorb-Schublade standen Klapp-Ueberschriften englisch:
   "Discount", "Order note", "Estimate shipping" — dazu die Cross-Selling-
   Ueberschrift "You may also like".

   Woher sie kommen: NICHT aus den Sprachdateien. Weder locales/de.json noch
   locales/en.default.json enthalten diese Zeichenketten; sections/
   cart-drawer.liquid hat ein leeres Schema und rendert nur das Snippet. Es
   sind also Theme-Einstellungen (Theme-Editor, Zahnrad → Warenkorb), die auf
   englisch stehen geblieben sind.

   Der saubere Ort ist deshalb der Theme-Editor. Dieses Skript ist die
   Zwischenloesung, bis die Felder dort gepflegt sind — und es steht der
   Pflege nicht im Weg: es tauscht ausschliesslich die exakten englischen
   Zeichenketten. Sobald im Editor deutscher Text steht, findet es nichts mehr
   und tut nichts.

   Zwei Reichweiten, mit Absicht:
   - Die drei Klapp-Ueberschriften nur innerhalb von #CartDrawer. Die
     Produktseiten haben eigene Klapptexte mit derselben Klasse, die hier
     nicht angefasst werden duerfen.
   - "You may also like" auf der ganzen Seite. Die Ueberschrift erscheint an
     zwei Stellen: als ergaenzende Produkte auf der Produktseite und als
     Empfehlung in der Warenkorb-Schublade.

   ZEITPUNKT — der eigentliche Knackpunkt (nachgebessert 01.09.2026):
   Beide Empfehlungsbloecke werden nachgeladen. Auf der Produktseite ist der
   Block beim load-Ereignis da, in der Schublade erst, wenn sie geoeffnet
   wird — also lange danach. Genau deshalb blieb dort "YOU MAY ALSO LIKE"
   stehen. Der Beobachter auf der Schublade prueft jetzt beide Wortlisten,
   nicht mehr nur die drei Klapptitel.

   Nur die Cross-Selling-Ueberschrift bekommt zusaetzlich die Klasse
   .vp-de-heading; vp-cart-text.css nimmt darueber die Versalien heraus —
   gewuenscht war die exakte Schreibweise "Andere Kunden kaufen auch", nicht
   alles gross. Die drei Klapp-Ueberschriften behalten ihre Versalien, weil
   sie sonst aus der Gestaltung der Schublade fallen (gemessen: "Bestellhinweis"
   und "Versand berechnen" standen ploetzlich klein zwischen den uebrigen
   Versalien-Zeilen).

   Ergaenzt 03.09.2026: die Beschriftung des Notizfelds ("Add a note to your
   order"). Sie ist ebenfalls eine Theme-Einstellung (Zahnrad -> Warenkorb ->
   Bestellhinweis -> Label; auf der Warenkorb-Seite ein Block der Vorlage
   "Warenkorb"). Gleiche Regel wie oben: steht dort deutscher Text, findet
   dieses Skript nichts mehr. <cart-note class="cart__note"> umschliesst das
   Label in der Schublade UND auf der Warenkorb-Seite, darum ein Selektor.
   Gewuenschte Schreibweise ist "Anmerkungen zu Ihrer Bestellung hinzufuegen",
   nicht alles gross — darum wird das Label wie die Cross-Selling-Ueberschrift
   mit .vp-de-heading markiert (vp-cart-text.css nimmt die Versalien heraus).

   Ausfallweg ohne JavaScript: die englischen Begriffe bleiben stehen.
   ============================================================================= */
(function () {
  'use strict';

  if (window.__vpCartDrawerDe) return;
  window.__vpCartDrawerDe = true;

  var DRAWER_TEXTS = {
    'discount': 'Rabattcode',
    'discount code': 'Rabattcode',
    'order note': 'Bestellhinweis',
    'estimate shipping': 'Versand berechnen'
  };

  var PAGE_TEXTS = {
    'you may also like': 'Andere Kunden kaufen auch',
    'you might also like': 'Andere Kunden kaufen auch'
  };

  var NOTE_TEXTS = {
    'add a note to your order': 'Anmerkungen zu Ihrer Bestellung hinzufügen'
  };

  var DRAWER_SELECTOR = '.accordion__title, .summary__title-name';
  var NOTE_SELECTOR = '.cart__note > label';
  var PAGE_SELECTOR = 'h1, h2, h3, h4, h5, h6, [class*="heading"], [class*="title"]';

  function translate(root, selector, texts, mark) {
    var nodes = root.querySelectorAll(selector);

    Array.prototype.forEach.call(nodes, function (el) {
      /* Nur Elemente ohne eigene Kindelemente anfassen — sonst wuerde eine
         Ueberschrift mit Icon oder Zaehler ihren Inhalt verlieren. */
      if (el.children.length) return;

      var key = el.textContent.trim().toLowerCase();
      if (!texts[key]) return;

      el.textContent = texts[key];
      if (mark) el.classList.add('vp-de-heading');
    });
  }

  function translateDrawer(drawer) {
    translate(drawer, DRAWER_SELECTOR, DRAWER_TEXTS, false);
    translate(drawer, NOTE_SELECTOR, NOTE_TEXTS, true);
    translate(drawer, PAGE_SELECTOR, PAGE_TEXTS, true);
  }

  function run() {
    try {
      var drawer = document.getElementById('CartDrawer');
      if (drawer) {
        translateDrawer(drawer);

        /* Die Schublade wird nach jeder Warenkorb-Aenderung neu aufgebaut und
           laedt ihre Empfehlungen beim Oeffnen nach — derselbe Grund, aus dem
           vp-tax-note.js einen Beobachter braucht. */
        if (!drawer.__vpObserved) {
          drawer.__vpObserved = true;
          new MutationObserver(function () {
            translateDrawer(drawer);
          }).observe(drawer, { childList: true, subtree: true });
        }
      }

      translate(document, PAGE_SELECTOR, PAGE_TEXTS, true);
      /* Warenkorb-Seite: dasselbe Label ausserhalb der Schublade. */
      translate(document, NOTE_SELECTOR, NOTE_TEXTS, true);
    } catch (e) {
      /* Eine fehlgeschlagene Verbesserung darf die Seite nicht blockieren. */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* Die ergaenzenden Produkte auf der Produktseite sind beim load-Ereignis da. */
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', run);
})();
